import { LoadingIndicatorProps } from 'react-select';
import { CircleSpinner } from 'ui/spinner';
import { BaseOption } from './types';

export const SelectLoadingIndicator = (props: LoadingIndicatorProps<BaseOption>) => {
  return <CircleSpinner {...props} size={16} />;
};
